import React, { useEffect, useRef } from "react";
import * as powerbi from "powerbi-client";

const PowerBIReport = ({ token, idReport, urlReport }) => {
  const reportContainer = useRef();

  useEffect(() => {
    if (!token || !idReport || !urlReport) {
      return;
    }

    const fetchAccessToken = async () => {
      try {
        const embedConfig = {
          type: "report",
          id: idReport,
          embedUrl: urlReport,
          accessToken: token,
          tokenType: powerbi.models.TokenType.Aad,
          settings: {
            panes: {
              filters: { visible: false },
              pageNavigation: { visible: true },
            },
          },
        };
        const powerbiService = new powerbi.service.Service(
          powerbi.factories.hpmFactory,
          powerbi.factories.wpmpFactory,
          powerbi.factories.routerFactory
        );

        powerbiService.embed(reportContainer.current, embedConfig);
      } catch (error) {
        console.error("Error al incrustar el informe:", error);
      }
    };

    fetchAccessToken();
  }, [token, idReport, urlReport]);

  return (
    <div ref={reportContainer} style={{ height: "600px", width: "100%" }} />
  );
};

export default PowerBIReport;
